import { INavigationArrowsData, INavigationArrowsStyle, NavigationArrowsData } from "@pageBuilder/typings";
import { CssProperties } from "../../../models/css-property";
import { ElementStyleService } from "../../../services/element-style.service";

export class SliderNavigationArrowsRenderer {

    constructor(private readonly styleService: ElementStyleService) {
    }

    public createNewArrows(): HTMLElement {
        const arrowsWrapper = document.createElement("div");
        arrowsWrapper.classList.add("navigation-arrows-wrapper");

        const leftArrow = document.createElement("button");
        const rightArrow = document.createElement("button");

        leftArrow.classList.add("navigation-arrow", "arrow-left");
        rightArrow.classList.add("navigation-arrow", "arrow-right");

        leftArrow.ariaLabel = "Previous slide";
        rightArrow.ariaLabel = "Next slide";

        const leftArrowSpan = document.createElement("span");
        const rightArrowSpan = document.createElement("span");

        leftArrow.append(leftArrowSpan);
        rightArrow.append(rightArrowSpan);

        arrowsWrapper.append(leftArrow, rightArrow);

        return arrowsWrapper;
    }

    public render(sectionElement: HTMLElement, data: INavigationArrowsData): void {
        let arrowsWrapper = sectionElement.querySelector(".navigation-arrows-wrapper");
        const sliderContent = sectionElement.querySelector(".slider-content");
        if (!arrowsWrapper && sliderContent) {
            arrowsWrapper = this.createNewArrows();
            sliderContent.append(arrowsWrapper);
        }

        if (data.enable) {
            this.renderLinksStyles(sectionElement, data.style);
        } else {
            this.cleanup(sectionElement);
        }
    }

    private renderLinksStyles(sectionElement: HTMLElement, data: INavigationArrowsStyle): void {
        const arrowsWrapperProps = new CssProperties();

        arrowsWrapperProps.tryAdd("--arrows-size", `${data.sizePx}px`);
        arrowsWrapperProps.tryAdd("--arrows-color", data.color);

        const navigationArrowProps = new CssProperties();
        navigationArrowProps.tryAdd("background-color", data.backgroundColor);

        this.styleService.setStyle(sectionElement, `#${sectionElement.id} .navigation-arrows-wrapper`, arrowsWrapperProps.data);
        this.styleService.setStyle(sectionElement, `#${sectionElement.id} .navigation-arrows-wrapper > .navigation-arrow`, navigationArrowProps.data);
    }

    private cleanupLinksStyles(sectionElement: HTMLElement): void {
        this.styleService.clearStyle(sectionElement, `#${sectionElement.id} .navigation-arrows-wrapper`);
        this.styleService.clearStyle(sectionElement, `#${sectionElement.id} .navigation-arrows-wrapper > .navigation-arrow`);
    }

    public cleanup(sectionElement: HTMLElement): void {
        this.cleanupLinksStyles(sectionElement);

        const wrapper = sectionElement.querySelector(".navigation-arrows-wrapper");
        wrapper?.remove();
    }

    public getAllContentSelectors(sectionElement: HTMLElement): Array<string> {
        return [`#${sectionElement.id} .navigation-arrows-wrapper`, `#${sectionElement.id} .navigation-arrows-wrapper > .navigation-arrow`];
    }

}
